import { MessageDescriptor } from 'react-intl';

import { MessageType } from '@savgroup-front-common/types';

import { safeFormattedIntlString } from '../formatters';

type PageTitlePart =
  | MessageType
  | MessageDescriptor
  | string
  | number
  | null
  | undefined;

export const buildPageTitle = (titles: PageTitlePart[] = []): string => {
  let cutNext = false;

  return titles
    .filter((title) => {
      if (!title || cutNext) {
        cutNext = true;

        return false;
      }

      return true;
    })
    .map((title) => safeFormattedIntlString(title ?? undefined))
    .reverse()
    .join(' - ');
};
